import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Message {
  type: 'error' | 'info' | 'warn';
  icon?: string;
  label?: string;
  message: string;
  metadata?: Record<string, unknown>;
}

@Component({
  selector: 'daas-consulting-production-messages',
  standalone: true,
  imports: [CommonModule, MatToolbarModule, MatIconModule],
  templateUrl: './messages.component.html',
  styleUrl: './messages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagesComponent implements OnChanges {
  @Input() messages: ReadonlyArray<Message> = [];
  @Output() readonly messageClick: EventEmitter<Message> =
    new EventEmitter<Message>();

  readonly hasMessages$: Observable<boolean>;
  readonly #hasMessages$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor() {
    this.hasMessages$ = this.#hasMessages$.asObservable();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['messages']) {
      this.#hasMessages$.next(
        Array.isArray(this.messages) && this.messages.length > 0
      );
    }
  }

  handleClick(message: Message): void {
    this.messageClick.emit(message);
  }
}
